import { mapGetters } from "vuex";
import { userMixin } from "../user/userMixin";

export const token = {
  computed: {
    ...mapGetters({
      hasAccessToken: "token/hasAccessToken",
      getAccessToken: "token/getAccessToken"
    })
  },
  mixins: [userMixin],
  methods: {
    setAccessToken(access_token) {
      localStorage.setItem("access_token", access_token);
      return this.$store.commit("token/setAccessToken", access_token);
    },
    revokeAccessToken() {
      localStorage.removeItem("access_token");
      return this.$store.commit("token/removeAccessToken");
    }
  }
};
